import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import TaskModalShell from 'pages/allTasks/TaskModal/TaskModalShell';
import { useExchangeTaskModal } from './useExchangeTaskModal';

interface ExchangeTaskModalProps {
  campaignId: string;
  isOpen: boolean;
  onClose: () => void;
  tasks: AutopilotTaskDto[];
  title: string;
}

const ExchangeTaskModal = ({
  campaignId,
  isOpen,
  onClose,
  tasks,
  title,
}: ExchangeTaskModalProps) => {
  const { campaign, ...controller } = useExchangeTaskModal({
    campaignId,
    isOpen,
    tasks,
  });

  if (!campaign) return null;

  return (
    <TaskModalShell
      title={title}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      {...controller}
    />
  );
};

export default ExchangeTaskModal;
